import PhotoSwipe from './libs/photoswipe-4.1.2.js';
import PhotoSwipeUI_Default from './libs/photoswipe-ui-default.js';

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

/**
 * Works without jQuery
 * @module GalleryLightbox
 */
(function GalleryLightbox() {
    /**
     * Provided function gets called when browser is ready for js rendering
     * @param fn
     */
    function ready(fn) {

        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /**
     * Renders the interactive logic for the lightbox
     *
     * For rendering a lightbox you need at least following markup:
     *
     * <div class="td-gallery-lightbox">
     *     <div class="td-gallery-lightbox-item" data-image-lightbox="{"width":940,"height":624,"src":"https:\/\/myhost\/a\/path\/an-image.jpg"}">
     *         // some content, mostly an image/TechDivision.Gallery/Public/NodeTypes/Thumbnails/Tiles.png
     *     </div>
     *     // some more items or content
     * </div>
     * // you also need the lightbox markup, you should use the fusion object "TechDivision.Gallery:LightboxTemplate" for this
     *
     * @class Lightbox
     * @param {Element} dom
     * @constructor
     */
    function Lightbox(dom) {

        // save context
        var _this = this;

        /**
         * the dom element of the overlay
         * @type {Element}
         */
        var pswpElement = dom.querySelector('.pswp-lightbox');

        /**
         * The raw items for the lightbox
         * @type {NodeList}
         */
        var lightboxRawItems = dom.querySelectorAll('.td-gallery-lightbox-item');

        /**
         * The built lightbox items
         * @type {Array}
         */
        this.lightboxItems = [];

        /**
         * Default options for PhotoSwipe
         * @type {object}
         */
        var options = {
            index: 0, // start at first slide,
            shareEl: false, // disable share options
            fullscreenEl: false, // disable full-screen button
            history: false
        };

        /**
         * Builds the lightbox items objects
         * @returns {Array}
         */
        this.buildLightboxItems = function() {
            // stop here if already built
            if(_this.lightboxItems.length > 0) {
                return _this.lightboxItems;
            }
            // iterate all raw items
            for (var i = 0; i < lightboxRawItems.length; i++) {
                var current = lightboxRawItems[i];
                // set the index, needed for opening with the right image
                current.setAttribute('data-lightbox-index', i);
                var imageLightBoxRawData = current.getAttribute('data-image-lightbox');
                if(!imageLightBoxRawData) {
                    console.log(current)
                    throw "Error: Clicked image has no or empty data-image-lightbox attribute";
                }
                var lightboxItemData = JSON.parse(imageLightBoxRawData);
                _this.lightboxItems.push({
                    src: lightboxItemData.src,
                    w: lightboxItemData.width,
                    h: lightboxItemData.height,
                    title: lightboxItemData.caption
                });
            }
            return _this.lightboxItems;
        };

        /**
         * Bins the needed events
         */
        this.bindEvents = function() {
            // iterate all lightbox items
            for (var i = 0; i < lightboxRawItems.length; i++) {
                var current = lightboxRawItems[i];

                current.addEventListener('click', function(event) {
                    // finds the target element(the lightbox item itself)
                    var targetElement = event.target.closest('.td-gallery-lightbox-item');
                    // build the items
                    _this.buildLightboxItems();
                    // set the index, should happen after item building
                    options.index = parseInt(targetElement.getAttribute('data-lightbox-index'), 10);

                    if(!pswpElement) {
                        throw "Error: There is now pswpElement. There has to be a least one single pswpElement. Probably you forgot to adding the TechDivision.Gallery:LightboxTemplate fusion object";
                    }
                    // create lightbox
                    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, _this.lightboxItems, options);
                    gallery.init();
                }, true);
            }
        };

        this.bindEvents();
        this.buildLightboxItems();
    }

    if (typeof document.addEventListener === 'function') {
        ready(function() {
            // get all lightbox instances
            var lightboxInstances = document.querySelectorAll('.td-gallery-lightbox');
            // build lightbox for each
            Array.prototype.forEach.call(lightboxInstances, function(el, i){
                var lightbox = new Lightbox(el);
            });

        });
    }
})();
